module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/2ccc6832176246d33114f67dd4fedd60.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver5.svg
// module id = c7bk
// module chunks = 1